<template>
  <div>
    <v-row>
      <v-col cols="12">
        <TipoCalculo v-model="model"/>
      </v-col>
      <v-col cols="12">
        <input-select v-if="!model.Codigo && !model.GarantiaSimulacao" label="Tipo de Operação" v-model="model.TipoOperacaoCred"
          @change="changeOperacao" :options="operacao" required />
        <input-text v-else label="Tipo de Operação" :value="model.TipoOperacaoNome" readonly disabled />
      </v-col>
        <v-col cols="12">
          <input-select v-if="!model.Codigo && !model.GarantiaSimulacao" label="Produto" v-model="model.TipoContratoSigla" @change="changeProduto"
            :options="produtos" return-object required/>
          <input-text v-else label="Produto" :value="model.TipoContratoDescricao" readonly disabled required/>
        </v-col>
        <v-col cols="12" class="py-0" v-if="!model.HasGarantia && model.TipoOperacaoCred !== 2 && model.TipoContratoSigla">
          <v-alert type="error" text>
            Não existe garantia cadastrada para esse produto
          </v-alert>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="6">
          <input-select label="Tipo de Assinatura" :options="assinaturas" v-model="model.TipoCCB" required>
          </input-select>
        </v-col>
      <v-col cols="12" class="pt-0">
        <v-label>Modalidade</v-label>
        <input-radiogroup name="Indexador" row v-model="model.TipoIndexador" @change="changeIndexador" required>
          <v-radio label="Pré-Fixado" :value="1" />
          <v-radio label="Pós-Fixado" :value="2" />
        </input-radiogroup>
      </v-col>
      <v-col cols="6">
        <input-select label="Indexador Pós Fixado" v-model="model.TipoIndiceFinan"
          :options="$api.Estruturadas.Indexador" :disabled="model.TipoIndexador !== 2"
          :required="model.TipoIndexador === 2" />
      </v-col>
      <v-col cols="6">
        <input-number label="Percentual Indexador" v-model="model.PercIndiceFinan"
          format="percent" :disabled="model.TipoIndexador !== 2"
          :required="model.TipoIndexador === 2" />
      </v-col>
      <v-col cols="6">
        <input-number label="Taxa de juros a.m." v-model="model.PercJurosMensal" precision="5" max="999.99999"
          format="percent" required />
      </v-col>
    </v-row>

    <PropostaEditDesembolso ref="desembolso" :value="model" @response="responseDesembolso"></PropostaEditDesembolso>
  </div>
</template>

<script>
export default {
  components: {
    PropostaEditDesembolso: () => import('./PropostaEditDesembolso.vue')
  },
  props: {
    value: null,
    isNotaComercial: { type: Boolean, default: false }
  },
  data () {
    return {
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    produtos () {
      const lista = this.$api.Estruturadas.GetProdutos(
        this.model.Cliente.DocumentoFederal,
        this.model.TipoOperacaoCred,
        this.$param.EST_PRODUTOS
      )
      return lista
    },
    assinaturas () {
      if (this.isNotaComercial) return this.$api.Estruturadas.TipoAssinatura.filter(tipo => tipo.value === 'D')
      const lista = this.$api.Estruturadas.GetProdutos(
        this.model.Cliente.DocumentoFederal,
        this.model.TipoOperacaoCred,
        this.$param.EST_PRODUTOS,
        this.model.TipoContratoSigla,
      )
      return lista
    },
    operacao () {
      const tipoOperacao = this.$api.Estruturadas.GetTipoOperacaoByTipoPessoa(
        this.model.Cliente.DocumentoFederal,
        this.$param.EST_PRODUTOS
      );
      return tipoOperacao;
    },
    tipoPessoaString () {
      const th = this
      var tipoPessoa = th.$api.UI.Format.SomenteNumeros(th.model.Cliente.DocumentoFederal).length === 11 ? 'PF' : 'PJ'
      return tipoPessoa
    }
  },
  methods: {
    load () {
      this.$refs.desembolso.load()
      this.$set(this.model, 'HasGarantia', true)
    },
    changeOperacao (value) {
      this.load()
      this.$set(this.model, 'TipoOperacaoNome', null);
      if (value) { this.$set(this.model, 'TipoOperacaoNome', this.$api.Estruturadas.TipoOperacaoCred.find(p => p.value === value).text); }
      this.$set(this.model, 'TipoIndiceFinan', null);
      this.$set(this.model, 'QtdeParcelasSolicitado', null);
      this.$set(this.model, 'Produto', null);
      this.$set(this.model, 'ModeloCalculo', null);
      this.$set(this.model, 'TipoIndexador', null);
      this.$set(this.model, 'PercIndiceFinan', null);
      this.$set(this.model, 'OutrosServicos', false);
      this.$set(this.model, 'VlrSolicitado', null);
      this.$set(this.model, 'VlrProdutoBem', null)
      this.$set(this.model, 'VlrTAC', null);
      this.$set(this.model, 'VlrSeguro', null)
      this.$set(this.model, 'VlrAvaliacao', null)
      this.$set(this.model, 'VlrVistoria', null)
      this.$set(this.model, 'TipoContratoSigla', null);
      this.$set(this.model, 'TipoCCB', null);
      this.$set(this.model, 'PercJurosMensal', null);
    },
    changeProduto (item) {
      const th = this
      th.load()
      th.$set(th.model, 'TipoContrato', null)
      if (item && item.value) {
        th.$set(th.model, 'TipoContratoSigla', item.value)
        th.$set(th.model, 'TipoContratoTela', item.value)
        th.$set(th.model, 'TipoContratoDescricao', item.value + ' - ' + item.text)
      }
      th.getGarantias()
    },
    getGarantias () {
      const param = this.$api.Estruturadas.garantiaBySigla(this)
      if (this.model.TipoOperacaoCred !== 2 && param) {
        if (param.garantias) {
          this.$set(this.model, 'HasGarantia', true)
        } else {
          this.$set(this.model, 'HasGarantia', false)
        }
      }
    },
    submit () {
      const th = this
      const produtosFiltrados = th.$param.EST_PRODUTOS.filter(el => el.TipoOperacao === th.model.TipoOperacaoCred && el.TipoPessoa === th.tipoPessoaString).reduce(l => l).Produtos
      if (produtosFiltrados.length > 0) {
        th.$set(th.model, 'CodigoVersaoCCB', produtosFiltrados.find(el => el.Sigla === th.model.TipoContratoSigla)[th.model.TipoCCB])
        th.$refs.desembolso.submit()
      } else {
        th.$api.UI.ShowError('Não foi possível encontrar o Código do Tipo de Operação Parâmetrizado')
      }
    },
    responseDesembolso (response) {
      const th = this
      th.model.Promotor = {}
      if (response.TipoDesembolso === th.$api.Enums.TipoDesembolso.Outros) {
        th.model.Promotor = response.Promotor
      }
      th.$set(th.model, 'TipoDesembolso', response.TipoDesembolso)
      th.$set(th.model, 'ContaPagamento', response.ContaPagamento)

      if (th.model.Codigo) {
        th.$api.Estruturadas.SaveProposta(th, function (response) {
          th.$emit('nextStep')
        })
      } else { th.$emit('nextStep') }
    },
    changeIndexador () {
      const th = this;
      if (th.model.TipoIndexador === 1) {
        th.$set(th.model, 'TipoIndiceFinan', '')
        th.$set(th.model, 'PercIndiceFinan', '')
      }
    }
  }
}
</script>
